module.exports = __webpack_public_path__ + "helveticaneueltstd-lt-webfont.09d78c142db49b5d2a48.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/helveticaneueltstd-lt-webfont.svg
// module id = ../../../../../src/assets/fonts/helveticaneueltstd-lt-webfont.svg
// module chunks = styles